const options = {
  5: "bg-rose-700/5",
  10: "bg-rose-700/10",
  25: "bg-rose-700/25",
  50: "bg-rose-700/50",
  75: "bg-rose-700/75",
  90: "bg-rose-700/90",
  100: "bg-rose-700",
};

const from = {
  5: "from-rose-700/5",
  10: "from-rose-700/10",
  25: "from-rose-700/25",
  50: "from-rose-700/50",
  75: "from-rose-700/75",
  90: "from-rose-700/90",
  100: "from-rose-700",
};

export default function getBackgroundRose700(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
